export function importAll(r) {
  return r.keys().map((key) => ({
    name: key.replace("./", "").replace(/\.(png|jpe?g|svg)$/, ""),
    logo: r(key),
  }));
}